import React from 'react';

export const PageTransfersAchImportView: React.FC = () => {
  return null;
};
